var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var PersonModel;
  return PersonModel = (function(_super) {

    __extends(PersonModel, _super);

    function PersonModel() {
      PersonModel.__super__.constructor.apply(this, arguments);
    }

    PersonModel.prototype.isTaxAccountant = false;

    PersonModel.prototype.isBookkeeper = false;

    PersonModel.prototype.isSales = false;

    PersonModel.prototype.pathRoot = function() {
      var url;
      url = core.getConfig().apiPrefix + 'person.json';
      if (this.isTaxAccountant) {
        url += '/tax_accountant';
      }
      if (this.isBookkeeper) {
        url += '/bookkeeper';
      }
      if (this.isSales) {
        url += '/sales';
      }
      return url;
    };

    PersonModel.prototype.defaults = function() {
      return {
        id: null,
        firstName: null,
        lastName: null,
        fullName: null,
        phone: null,
        email: null,
        company: null
      };
    };

    PersonModel.prototype.imageURL = function() {
      return '/templates/common/images/bookkeepers/' + (this.get('firstName') + "-" + this.get('lastName')).toLowerCase() + '.jpg';
    };

    PersonModel.prototype.makeTaxAccountant = function() {
      this.isTaxAccountant = true;
      this.isBookkeeper = false;
      return this.isSales = false;
    };

    PersonModel.prototype.makeBookkeeper = function() {
      this.isTaxAccountant = false;
      this.isBookkeeper = true;
      return this.isSales = false;
    };

    PersonModel.prototype.makeSales = function() {
      this.isTaxAccountant = false;
      this.isBookkeeper = false;
      return this.isSales = true;
    };

    return PersonModel;

  })(BaseModel);
});
